import tw, { styled, css } from "twin.macro";

import banner from "../../assets/svg/homeBanner.svg";
import "antd/dist/antd.css";
import { Button } from "antd";
import { COLORS } from "../../lib/styles/styles";

export const active = (props) => css`
	${tw`bg-appPink font-semibold shadow-md rounded-3xl min-w-min border-none text-white py-2 px-4 inline-flex gap-1 items-center justify-evenly hover:(cursor-pointer shadow-md border border-white)`}
	font-size: 0.75rem;
	@media (max-width: 1217px) {
		font-size: 0.75rem;
	}
`;

export const inactive = (props) => css`
	${tw`font-semibold shadow-md rounded-3xl min-w-min border-none text-white py-2 px-5 inline-flex gap-1 items-center justify-evenly hover:(cursor-pointer shadow-md border border-white)`}
	font-size: 0.75rem;
	background-color: rgba(255, 255, 255, 0.1);
	@media (max-width: 1217px) {
		font-size: 0.75rem;
	}
`;

export const currencyStyle = (props) => css`
	${tw`rounded-full px-2 py-1 mr-1 flex items-center justify-center`}
	background: #9F4636;
`;
export const notCurrencyStyle = (props) => css`
	${tw` px-1 py-1 text-sm flex items-center justify-center`}
`;

export const Wrapper = styled.div`
	${tw`h-full w-full p-4 md:p-6 m-0 flex flex-row flex-wrap`};
	@media (max-width: 1217px) {
		overflow-y: scroll;
	}

	.carousel-container {
		${tw`h-full w-full md:w-96`};
	}
	.react-multi-carousel-dot {
		button {
			${tw`mb-2 h-1.5! w-4! rounded-md`};
		}
	}

	.main {
		${tw`mt-4 w-full pb-8`}
		flex: 3;

		.banner {
			${tw`flex p-5! flex-col flex-wrap text-white justify-around`}
			/* background: url(${banner}); */
			background-color: ${COLORS.appTextDark};
			min-height: 240px;
			width: 100%;
			background-repeat: no-repeat;
			background-position: center;
			background-size: cover;
			background-blend-mode: multiply;
			border-radius: 20px;
		}

		.tell-story {
			background: #ffffff;
			border: 1px solid #f0f6fd !important;
			box-shadow: 0px 10px 40px rgba(231, 237, 243, 0.4);
			border-radius: 20px;
			.action-title {
				${tw`opacity-70 font-bold text-xs md:text-sm leading-5 pt-1`}
			}
			.card-container {
				-ms-overflow-style: none; /* IE and Edge */
				scrollbar-width: none;
				&::-webkit-scrollbar {
					display: none;
				}
			}
		}

		.pre-header {
			font-size: 0.875rem;
			opacity: 0.5;
		}
		@media (max-width: 1217px) {
			width: 100%;
			padding: 0px;
		}
	}

	.fadedBg {
		background: rgb(255, 255, 255, 0.1);
		border: 1.152px solid rgba(255, 255, 255, 0.1);
		box-sizing: border-box;
		border-radius: 32.256px;
	}
	.midFadedBg {
		background: rgba(50, 50, 50, 0.5);
		backdrop-filter: blur(4px);
		border-radius: 50px;
	}

	.sider {
		display: block;
		@media (max-width: 1217px) {
			display: none;
		}
	}
	.inner-tl {
		${tw`ml-1 md:ml-4 mt-4`};
		display: none;
		@media (max-width: 1217px) {
			display: block;
		}
	}

	.no-scroll {
		-ms-overflow-style: none !important; /* IE and Edge */
		scrollbar-width: none !important;
		&::-webkit-scrollbar {
			display: none !important;
		}
	}
`;

export const FundWalletBtn = styled(Button)`
	${tw`bg-appLightPink text-appPink rounded-2xl font-semibold px-3 py-1 border-none hover:(shadow-md text-appPinkSaturated font-bold cursor-pointer)`}
`;
